/* vl-advisor-entry — opens the bed advisor ("Yatak Testi") in a dialog on the page the visitor is on
   (snippets/vl-advisor-entry.liquid). The link itself goes to the test page, so without this script, or when the
   page cannot be fetched, the visitor simply lands there. The test's markup, texts and settings are taken from that
   page as it is rendered (one source: the page template), its stylesheet and script are loaded on first use. */
(function () {
  'use strict';
  if (window.vlAdvisorEntry) return; window.vlAdvisorEntry = true;
  if (!window.HTMLDialogElement || !window.DOMParser || !window.fetch) return;
  var dialog = null, opener = null;
  var track = function (type, meta) { try { if (window.vlTrack && window.vlTrack.send) window.vlTrack.send(type, meta || {}); } catch (e) {} };
  var once = function (tag, attr, url) {
    if (!url) return; var sel = tag + '[' + attr + '="' + url + '"]'; if (document.querySelector(sel)) return;
    var el = document.createElement(tag); if (tag === 'link') el.rel = 'stylesheet'; else el.defer = true; el[attr] = url; document.head.appendChild(el);
  };
  /* while the dialog is open the test has the floor: the wheel and the cards wait (they read data-vl-quiz) */
  var floor = function (on) {
    var d = document.documentElement;
    if (on) d.setAttribute('data-vl-quiz', 'dialog');
    else if (d.hasAttribute('data-vl-quiz')) { d.removeAttribute('data-vl-quiz'); try { document.dispatchEvent(new CustomEvent('vl:quiz:idle')); } catch (e) {} }
  };
  var close = function () { if (!dialog) return; var d = dialog; dialog = null; try { d.close(); } catch (e) {} d.remove(); floor(false); if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); } } };
  var open = function (a) {
    var url = a.getAttribute('href'); if (!url) return false;
    opener = a; once('link', 'href', a.getAttribute('data-css'));
    dialog = document.createElement('dialog'); dialog.className = 'vl-ba-dialog'; dialog.setAttribute('aria-label', a.textContent.replace(/\s+/g, ' ').trim().slice(0, 120));
    dialog.innerHTML = '<div class="vl-ba-dialog__bar"><button type="button" class="vl-ba-dialog__close" data-vl-advisor-close aria-label="' + (a.getAttribute('data-close') || 'Kapat').replace(/"/g, '&quot;') + '">' +
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="vl-ba-dialog__body"><p class="vl-ba-dialog__state" role="status"></p></div>';
    dialog.querySelector('.vl-ba-dialog__state').textContent = a.getAttribute('data-loading') || '';
    document.body.appendChild(dialog);
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog || (e.target.closest && e.target.closest('[data-vl-advisor-close]'))) close(); });
    try { dialog.showModal(); } catch (e) { dialog.remove(); dialog = null; return false; }
    floor(true);
    var mine = dialog, from = a.getAttribute('data-from') || 'product';
    track('quiz_open', { from: from });
    fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (html) {
        if (dialog !== mine) return;
        var doc = new DOMParser().parseFromString(html, 'text/html'), el = doc.querySelector('vl-bed-advisor');
        if (!el) throw new Error('no test on that page');
        el.setAttribute('data-from', from); el.setAttribute('data-autostart', '');
        var h1 = el.querySelector('h1'); if (h1) { var h2 = doc.createElement('h2'); h2.className = h1.className; h2.innerHTML = h1.innerHTML; h1.parentNode.replaceChild(h2, h1); }
        var body = mine.querySelector('.vl-ba-dialog__body'); body.textContent = '';
        body.appendChild(document.importNode(el, true));
        once('script', 'src', a.getAttribute('data-js'));
      })
      .catch(function () { if (dialog === mine) { close(); location.href = url; } });
    return true;
  };
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-vl-advisor-open]') : null;
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
    if (open(a)) e.preventDefault();
  });
})();
